import { Main } from '@components/Main';
import { PageContent } from '@components/PageContent';
import { PageTitle, PageTitleText } from '@components/PageTitle';
import { useData } from '@hooks/useData';
import { useEffectOnce } from '@hooks/useEffectOnce';
import { useField } from '@hooks/useField';
import useLoading from '@hooks/useLoading';
import useMessage from '@hooks/useMessage';
import { useModalWindow } from '@hooks/useModalWindow';
import { EnumSortDirection } from '@hooks/useRequest';
import { EnumEmpresa, useEmpresaCombo } from '@model/Empresa';
import ILinha from '@model/Linha';
import { EnumOperadora, useOperadoraCombo } from '@model/Operadora';
import { IRelatorioConferenciaChipFilter, useRelatorioService } from '@services/RelatorioService';
import React from 'react';
import { ConferenciaChipDetalhesModal } from './ConferenciaChipDetalhesModal';
import { ConferenciaChipFilter } from './ConferenciaChipFilter';
import { ConferenciaChipTable } from './ConferenciaChipTable';

export type RelatorioConferenciaChipProps = {
}

export function RelatorioConferenciaChip (props: RelatorioConferenciaChipProps) {
    const data = useData<ILinha, IRelatorioConferenciaChipFilter>({
        filter: {
            ddd: useField(),
            numeroSemMascara: useField(),
            empresaId: useField(EnumEmpresa.None),
            operadoraId: useField(EnumOperadora.None)
        },

        sortField: {
            name: "numeroSemMascara",
            direction: EnumSortDirection.Asc
        }
    })

    const detalhesModal = useModalWindow();

    const loading = useLoading();
    const message = useMessage();
    const relatorioService = useRelatorioService();
    const empresaCombo = useEmpresaCombo();
    const operadoraCombo = useOperadoraCombo();

    React.useEffect(() => {
        if (!loading.isLoading) {
            loading.start();
            relatorioService.listarConferenciaChip(data.requestedData)
                .then(data.handleResultResponse)
                .catch(message.showException)
                .finally(loading.stop);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data.requestedData]);

    useEffectOnce(() => {
        empresaCombo.loadOptions();
        operadoraCombo.loadOptions();
    })

    return (
        <React.Fragment>
            <Main>
                <PageTitle>
                    <PageTitleText text="Relatório de Linhas Órfãs" />
                </PageTitle>

                <PageContent>
                    <ConferenciaChipFilter
                        filter={data.filter}
                        isLoading={loading.isLoading}
                        empresaCombo={empresaCombo}
                        operadoraCombo={operadoraCombo}
                    />
                    
                    <ConferenciaChipTable
                        data={data}
                        isLoading={loading.isLoading}
                        detalhesModal={detalhesModal}
                    />
                </PageContent>
            </Main>

            {
                data.focusedRow !== undefined && (
                    <React.Fragment>
                        <ConferenciaChipDetalhesModal 
                            linha={data.focusedRow}
                            modal={detalhesModal}
                        />
                    </React.Fragment>
                )
            }
        </React.Fragment>
    )
}